import FormBuilderConfig from "../../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import IButtonBuilder from "../../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import ITextBuilder from "../../../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";

export type Inputs = "consolidado" | "totalVentas" | "numeroProspectos";
export type Buttons = "aceptar" | "cancelar";

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "consolidado",
      label: "* Compromiso (Puntos de Alcance)",
      bts: { mCol: 12 },
      component: ITextBuilder
    },
    {
      name: "totalVentas",
      label: "* Compromiso (Ingresos)",
      bts: { mCol: 12 },
      component: ITextBuilder
    },
    {
      name: "numeroProspectos",
      label: "* Compromiso (Prospectos)",
      bts: { mCol: 12 },
      component: ITextBuilder
    }
  ],
  buttons: [
    {
      name: "aceptar",
      label: "Homologar",
      isSubmit: true,
      component: IButtonBuilder,
      bts: { mCol: 6 }
    },
    {
      name: "cancelar",
      label: "Cancelar",
      component: IButtonBuilder,
      bts: { mCol: 6 }
    }
  ],
  validations: {
    consolidado: {
      required: {
        validator: value => !value,
        message: () => "Este campo es requerido"
      },
      minNumber: {
        validator: value => value && Number(value) < 0,
        message: () => "Debe ser mayor o igual a 0"
      }
    },
    totalVentas: {
      required: {
        validator: value => !value,
        message: () => "Este campo es requerido"
      },
      minNumber: {
        validator: value => value && Number(value) < 0,
        message: () => "Debe ser mayor o igual a 0"
      }
    },
    numeroProspectos: {
      required: {
        validator: value => !value,
        message: () => "Este campo es requerido"
      },
      minNumber: {
        validator: value => value && Number(value) < 0,
        message: () => "Debe ser mayor o igual a 0"
      }
    }
  },
  rows: [
    ["consolidado"],
    ["totalVentas"],
    ["numeroProspectos"],
    ["aceptar", "cancelar"]
  ]
};
